export const API_BASE = "https://aiagenthub.kr/api/";  //프리 로컬 테스트
// export const API_BASE = "http://localhost:8010/api/";  //프리 로컬 테스트

export const WS_BASE = "wss://aiagenthub.kr/ws/";
// export const WS_BASE = "ws://localhost:8010/ws/";
